import { connect } from 'react-redux';
import { handleFetchBrokerDealerStates } from '../../../actions/admin_actions';
import BrokerDealerStates from '../../../components/admin/riaContacts/BrokerDealerStates';

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
    brokerDealerStates: state.brokerDealerStates.brokerDealerStates
  }
}

const BrokerDealerStatesContainer = connect(mapStateToProps, { handleFetchBrokerDealerStates })(BrokerDealerStates)

export default BrokerDealerStatesContainer;